import { getCookie, setCookie } from '../utils/cookiesUtils';
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { handleAxiosError } from '../utils/commonUtils';
import '../css/TeamAccept.css';
import Logo from '../assets/img/everythingdata-logo.png';
import alertImage from '../assets/img/alert.png'; // Import the alert image
import checkImage from '../assets/img/check.png'; // Import the alert image
import TeamsApi from '../api/teamsApi';
import UserApi from '../api/usersApi';
import { SuccessResponse } from '../models/system/successResponse';
import { DASHBOARD_COOKIE_EXPIRE_TIME } from '../config/system/systemConfig';
import { decodeJWT } from '../utils/jwtUtil';
import AuthApi from '../api/authApi';


interface RouteParams {
  invite_id: string;
}

const TeamAccept: React.FC = () => {
  const { invite_id } = useParams<RouteParams>();
  const [token, setToken] = useState<string | null>(null);

  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<boolean>(false);


  const selectTeamApi = async (team_id: string, user_id: string) => {
    try {
      const response = await AuthApi.selectTeam(user_id, team_id, '');
      if (response.success) {
        const data = (response as SuccessResponse).data;
        setCookie('dashboard_token', data.token, DASHBOARD_COOKIE_EXPIRE_TIME);
      }
      else {
        toast.error(response.message);
      }
    }
    catch (error: any) {
      toast.error(handleAxiosError(error).message);
    }
  };

  const acceptInvite = async (invite_id: string) => {
    try {
      const token = getCookie('dashboard_token');
      if (!token) {
        window.location.href = `/login?team_accept_uri=${encodeURIComponent(window.location.href)}`;
        return;
      }

      const decodedToken = decodeJWT(token);
      const user_id = decodedToken?.user_id;

      const response = await TeamsApi.acceptInvite(invite_id);
      if (response.success) {
        const data = (response as SuccessResponse).data;
        const team_id = data?._id;

        setMessage(response.message);
        setError(false);

        if (team_id && user_id) {
          selectTeamApi(user_id, team_id);
        }
      }
      else {
        setError(true);
        setMessage(response.message);
      }
    }
    catch (error: any) {
      toast.error(handleAxiosError(error).message);
    }
  };


  useEffect(() => {
    const storedToken = getCookie('dashboard_token'); // Retrieve token

    if (!storedToken) {
      setCookie('pending_invite_id', invite_id, 1);

      const loginUrl = `/login?team_accept_uri=${encodeURIComponent(window.location.href)}`;

      window.location.href = loginUrl;
    } else {
      setToken(storedToken);

      const checkInvite = async () => {
        try {
          await acceptInvite(invite_id);

          setTimeout(() => {
            document.querySelector('.content-container')?.classList.add('show');
          }, 500);
        } catch (error: any) {
          toast.error(handleAxiosError(error).message);
        }
      };

      checkInvite();
    }
  }, [invite_id]);


  return (
    <div className="page-container">
      <div className="logo">
        <img src={Logo} alt="everythingData" style={{ maxWidth: "500px", height: "auto" }} />
      </div>
      <div className={`content-container ${error ? 'error' : 'success'}`}>
        <div className="message-container">
          <img
            src={error ? alertImage : checkImage}
            alt={error ? 'Alert' : 'Check'}
            className="status-image"
          />
          <p className={`message ${error ? 'error-message' : 'success-message'}`}>{message}</p>
        </div>
      </div>
      <Link to="/connections" className="button">
        Go to Dashboard
      </Link>
    </div>
  );
};

export default TeamAccept;
